/**
 * Endpoints públicos sobre OTROS usuarios — útil para componer ofertas de intercambio.
 */
import { api } from "./client";

export async function fetchUserDuplicates(userId: number): Promise<number[]> {
  return api<number[]>(`/inventory/users/${userId}/duplicates`);
}

export async function fetchUserMissing(userId: number): Promise<number[]> {
  return api<number[]>(`/inventory/users/${userId}/missing`);
}

export interface UserDirectoryRow {
  id: number;
  name: string;
  handle: string | null;
  city: string | null;
  country: string;
  region: string | null;
  avatar_color: string;
  initials: string;
  verified: boolean;
  stars_avg: number;
  trades_completed: number;
  level: number;
  album_pct: number;
  dups_unique: number;
  dups_total: number;
}

export async function fetchUsersDirectory(opts: { q?: string; limit?: number; offset?: number } = {}): Promise<UserDirectoryRow[]> {
  const params = new URLSearchParams();
  if (opts.q) params.set("q", opts.q);
  if (opts.limit) params.set("limit", String(opts.limit));
  if (opts.offset) params.set("offset", String(opts.offset));
  const qs = params.toString();
  return api<UserDirectoryRow[]>(`/users/with-dups${qs ? `?${qs}` : ""}`);
}
